import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-monitor",
  "use": "icon-monitor-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-monitor\"><path d=\"M0 0h1024v853.312H0V0z m85.312 85.312V768h853.376V85.312H85.312z m85.376 853.376h682.624V1024H170.688v-85.312z m480.32-423.424L449.536 358.848 339.84 515.2H170.688V429.888h124.8l135.68-193.408 249.024 193.408h173.12v85.376h-202.304z\" fill=\"currentColor\" p-id=\"1527\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol